import { useEffect } from 'react';
import VerifyForm from '../../components/VerifyForm';
import { Container } from './style';

const RedefinePassword = () => (
    <Container>
      <VerifyForm redefine/>
    </Container>
  );


export default RedefinePassword;
